import { MenuItem } from "./menu.types";

export const menuItems4: MenuItem[] = [
  {
    id: 33,
    label: "Service Ticketing",
    icon: "las la-ticket-alt",
    permissionId: 31,
    subItems: [
      { id: 34, label: "Tickets", icon: "las la-minus", to: "/tickets", permissionId: 31 },
    ],
  },
  { id: 35, label: "Help", icon: "lar la-life-ring", to: "/Help", permissionId: 33 },
];
